var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconDress(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b063de"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#793981"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 182.024,
    x2: 283.382,
    xlinkHref: "#lg1",
    y1: 275.255,
    y2: 486.331
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#662d90",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1835,
    stopColor: "#5c2d85",
    stopOpacity: 0.184
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6917,
    stopColor: "#442d6c",
    stopOpacity: 0.692
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b2d63"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 130.498,
    x2: 261.067,
    xlinkHref: "#lg2",
    y1: 291.22,
    y2: 397.643
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 156.094,
    x2: 354,
    xlinkHref: "#lg1",
    y1: 236.629,
    y2: 534.001
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 350.457,
    x2: 260.351,
    xlinkHref: "#lg2",
    y1: 297.679,
    y2: 341.151
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 223.091,
    x2: 317.282,
    xlinkHref: "#lg1",
    y1: 306.022,
    y2: 337.002
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 398.136,
    x2: 337.428,
    xlinkHref: "#lg2",
    y1: 276.33,
    y2: 318.608
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 212.55,
    x2: 307.468,
    xlinkHref: "#lg1",
    y1: 52.725,
    y2: 100.184
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 284.283,
    x2: 202.309,
    xlinkHref: "#lg2",
    y1: 88.985,
    y2: -30.021
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 249.914,
    x2: 289.283,
    xlinkHref: "#lg1",
    y1: 5.102,
    y2: 115.12
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 305.23,
    x2: 328.959,
    xlinkHref: "#lg2",
    y1: 31.544,
    y2: 127.18
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 326.872,
    x2: 326.872,
    xlinkHref: "#lg2",
    y1: 223.921,
    y2: 49.165
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 111.386,
    y2: 139.049
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffda2d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fdbf00"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m478.123 419.79c4.221 6.699 2.655 14.226-3.706 17.384-47.061 23.362-126.808 38.964-219.417 38.964s-172.356-15.602-219.417-38.963c-6.361-3.158-7.928-10.685-3.706-17.384l147.155-299.683h151.936z",
    fill: "url(#SVGID_1_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m195.008 120.108-123.222 331.452c-13.6-4.362-25.731-9.19-36.199-14.388-6.365-3.158-7.929-10.684-3.707-17.378l147.152-299.686z",
    fill: "url(#SVGID_2_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.84 465.648c-53.02 27.536-310.659 27.536-363.679 0-3.669-1.906-4.894-6.242-3.051-10.352l124.897-335.188h119.987l124.897 335.188c1.842 4.111.618 8.447-3.051 10.352z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m436.843 465.645c-15.417 8.006-48.741 13.719-89.765 17.049.128-.238.239-.467.348-.704l-63.494-361.882h31.059l124.899 335.186c1.839 4.112.621 8.445-3.047 10.351z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m347.431 481.992c-17.317 37.343-167.546 37.343-184.863 0l63.498-361.885h57.867z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m474.413 437.172c-10.469 5.197-22.599 10.026-36.199 14.388l-123.222-331.452h15.976l147.152 299.686c4.223 6.694 2.658 14.22-3.707 17.378z",
    fill: "url(#SVGID_6_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m178.995 27.792h152.009v92.316h-152.009z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m331.009 27.797v92.308h-97.053l-54.965-54.956v-37.352z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m353.983 3.041c-.799-2.582-3.774-3.791-6.175-2.55-19.771 10.22-50.794 17.055-86.067 17.826-2.233.054-4.476.076-6.741.076s-4.509-.022-6.741-.076c-35.273-.771-66.296-7.605-86.067-17.826-2.401-1.241-5.376-.032-6.175 2.55-1.422 4.595-2.246 9.451-2.385 14.476-.85 30.737 22.662 55.234 53.409 55.589 11.667.135 22.495-3.423 31.387-9.579 9.917-6.866 23.228-6.866 33.144 0 8.892 6.156 19.72 9.714 31.387 9.579 30.747-.356 54.259-24.852 53.409-55.589-.139-5.025-.963-9.881-2.385-14.476z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m356.368 17.517c-.139-5.025-.963-9.881-2.385-14.476-.799-2.582-3.774-3.791-6.175-2.55-19.771 10.221-50.794 17.055-86.067 17.826-2.233.054-4.476.076-6.741.076-2.25 0-4.479-.022-6.698-.075-.026.701-.053 1.401-.053 2.108 0 13.031 4.501 25.005 12.026 34.469 2.363 2.972 5.438 5.261 8.772 7.078.863.47 1.706.988 2.526 1.555 8.688 6.015 19.223 9.55 30.584 9.583 30.298.087 55.048-25.308 54.211-55.594z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m476.913 435.5-303.65-303.65 5.771-11.746h151.933l147.154 299.691c3.602 5.717 2.988 12.016-1.208 15.705z",
    fill: "url(#SVGID_11_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m170.609 123.195c-1.069 5.19 2.342 10.219 7.55 11.197 22.269 4.179 48.696 6.594 76.841 6.594 28.146 0 54.573-2.415 76.841-6.594 5.208-.977 8.62-6.007 7.55-11.197l-2.241-10.875c-1.006-4.882-5.629-8.122-10.567-7.446-15.377 2.107-34.534 3.546-55.554 4.039-8.891.204-23.168.204-32.059 0-21.02-.494-40.177-1.933-55.554-4.039-4.938-.677-9.562 2.564-10.567 7.446z",
    fill: "url(#SVGID_12_)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDress);
export default __webpack_public_path__ + "static/media/icon-dress.4da3e7845c360299be5f2fd11805709a.svg";
export { ForwardRef as ReactComponent };